import styled from 'styled-components';
import Screen from '../../../../shared/utils/screen';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

const ChannelListArrowLeftContainer = styled.div<{ hasDial?: boolean }>`
  position: fixed;
  top: ${523 * Screen.widthRatio}px;
  left: ${({ hasDial }) => (hasDial ? 12 : 120) * Screen.widthRatio}px;
`;

export default withOpacity(ChannelListArrowLeftContainer);
